import { Address } from "viem"
import {
  TransactionItemBase,
  TransactionItemUnion,
  TransactionLabel,
} from "./baseTransactionTypes"

export type WETHTransaction = {
  label: TransactionLabel.WRAP | TransactionLabel.UNWRAP
  vault: Address
}

export type WETHTransactionItem = TransactionItemBase<WETHTransaction>

export function isWETHTransactionItem(
  item?: TransactionItemUnion,
): item is WETHTransactionItem {
  return (
    item?.label === TransactionLabel.WRAP ||
    item?.label === TransactionLabel.UNWRAP
  )
}

export type WrapTransaction = WETHTransaction & {
  label: TransactionLabel.WRAP
  totalAssets?: string
  totalShares?: string
}

export type WrapTransactionItem = TransactionItemBase<WrapTransaction>

export function isWrapTransactionItem(
  item?: TransactionItemUnion,
): item is WrapTransactionItem {
  return item?.label === TransactionLabel.WRAP
}

export type UnwrapTransaction = WETHTransaction & {
  label: TransactionLabel.UNWRAP
  isMax?: boolean
}

export type UnwrapTransactionItem = TransactionItemBase<UnwrapTransaction>

export function isUnwrapTransactionItem(
  item?: TransactionItemUnion,
): item is UnwrapTransactionItem {
  return item?.label === TransactionLabel.UNWRAP
}
